import { createRouter, createWebHistory } from 'vue-router'
import Landing from '../components/Landing.vue'
import Start from '../components/Start.vue'
import Intro from '../components/Intro.vue'
import Result from '../components/Result.vue'

const routes = [
  {
    path: '/',
    name: 'Landing',
    component: Landing,
    
  },
  {
    path: '/intro',
    name: 'Intro',
    component: Intro
  },
  {
    path: '/start',
    name: 'Start',
    component: Start
  },
  {
    path: '/result',
    name: 'Result',
    component: Result
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  data() {
    return {
      
    }
  },
})

router.afterEach((to, from) => {
  const toDepth = to.path.split('/').length
  const fromDepth = from.path.split('/').length
  to.meta.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left'
})
export default router